export default __webpack_public_path__ + "static/media/changeLogIcon.72d5c71e.svg";